import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import theme from "./styles/MUI/theme";
import { store } from "./store/store";
import { AppRoutes } from "./routes/AppRoutes";

const App = () => {
	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<AppRoutes />
			</ThemeProvider>
		</Provider>
	);
};

export default App;
